import {createSlice} from '@reduxjs/toolkit';
//types
import {IOrganizationAuctionReducer} from '../../utils/types';
//actions
import {getAuction, getAuctionCategories, getAuctionList, getAuctionWonList} from './actions';
//operations
import {
	pendingOperation,
	rejectedOperation,
	getAuctionListOperation,
	clearAuctionDataOperation,
	getAuctionCategoriesOperation,
	getAuctionOperation,
	getAuctionWonListOperation,
} from './operations';

export const initialState: IOrganizationAuctionReducer = {
	auctionList: null,
	auctionCategories: null,
	auction: null,
	isLoading: false,
	auctionWonList: null,
};

const organizationAuctionStore = createSlice({
	name: 'organizationAuction',
	initialState,
	reducers: {
		clearAuctionData: (state) => clearAuctionDataOperation(state, initialState),
	},
	extraReducers: (builder) => {
		builder.addCase(getAuctionList.pending, pendingOperation);
		builder.addCase(getAuctionList.fulfilled, getAuctionListOperation);
		builder.addCase(getAuctionList.rejected, rejectedOperation);

		builder.addCase(getAuctionCategories.pending, pendingOperation);
		builder.addCase(getAuctionCategories.fulfilled, getAuctionCategoriesOperation);
		builder.addCase(getAuctionCategories.rejected, rejectedOperation);

		builder.addCase(getAuction.pending, pendingOperation);
		builder.addCase(getAuction.fulfilled, getAuctionOperation);
		builder.addCase(getAuction.rejected, rejectedOperation);

		builder.addCase(getAuctionWonList.pending, pendingOperation);
		builder.addCase(getAuctionWonList.fulfilled, getAuctionWonListOperation);
		builder.addCase(getAuctionWonList.rejected, rejectedOperation);
	},
});

export const {clearAuctionData} = organizationAuctionStore.actions;

export default organizationAuctionStore.reducer;
